import React, { Component } from "react";
import { Button, Accordion } from "react-bootstrap";
import ReactPlayer from "react-player";
import { connect } from "react-redux";
import axios from "axios";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class LessonCard extends Component {
  state = {
    lessoncontent: [],
  };
  componentDidMount() {
    this.fetchlesson({
      school: this.props.user.user.school.id,
      course_section: this.props.Section,
      ordering: "lesson_position",
    });
  }

  fetchlesson = (params = {}) => {
    axios
      .get(`/courseapi/lesson`, {
        params: { ...params },
      })
      .then((res) => {
        this.setState({
          lessoncontent: res.data,
        });
      });
  };

  ref = (player) => {
    this.player = player;
  };
  render() {
    return (
      <div>
        {this.state.lessoncontent.length === 0 ? null : (
          <div>
            <div className="th-14 pt-3 th-primary">{this.props.name}</div>
            <div className="border rounded shadow-sm p-3">
              <Accordion defaultActiveKey={null}>
                {this.state.lessoncontent?.map((content, index) => {
                  return (
                    <div key={index}>
                      <Accordion.Toggle
                        as={Button}
                        variant="link"
                        eventKey={index + 1}
                        style={{
                          padding: 0,
                          textDecoration: "none",
                          boxShadow: "none",
                          width: "100%",
                        }}
                      >
                        <div className="d-flex justify-content-between">
                          <div className="d-flex">
                            <div className="th-12 th-black text-left pr-1">
                              {this.state.lessoncontent.indexOf(content) + 1}.{" "}
                            </div>
                            <div className="th-12 th-black text-left">
                              {content.lesson_name}
                            </div>
                          </div>
                          {content.content_type === "document" ? (
                            <i
                              className="fa fa-paperclip th-primary pl-1 th-20"
                              aria-hidden="true"
                            ></i>
                          ) : null}
                          {content.content_type === "youtubelink" ? (
                            <i
                              className="fa fa-play-circle-o th-primary pl-1 th-20"
                              aria-hidden="true"
                            ></i>
                          ) : null}
                          {content.content_type === "link" ||
                          content.content_type === "embeddedlink" ? (
                            <i
                              className="fa fa-external-link th-primary pl-1 th-20"
                              aria-hidden="true"
                            ></i>
                          ) : null}
                        </div>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey={index + 1}>
                        <div className="py-2">
                          {/*<div>
                        <ReactPlayer
                          url={item.url}
                          width="100%"
                          height="100%"
                          controls={true}
                        />
                      </div>*/}
                          <p className="th-12 th-grey">{content.text}</p>
                          {content.content_type === "document" ? (
                            <div className="text-center">
                              <a
                                className="btn th-btn-primary-outline mt-2 px-4 py-1"
                                href={content.document}
                                download
                              >
                                Download/View
                              </a>
                            </div>
                          ) : (
                            ""
                          )}

                          {content.content_type === "youtubelink" ? (
                            <div>
                              <ReactPlayer
                                ref={this.ref}
                                url={`${content.youtube_link}`}
                                controls={true}
                                width="100%"
                                height="100%"
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          {content.content_type === "link" ? (
                            <div className="text-center ">
                              <a
                                className="btn th-btn-primary-outline mt-2 px-4 py-1"
                                href={content.link}
                              >
                                View
                              </a>
                            </div>
                          ) : (
                            ""
                          )}

                          {content.content_type === "embeddedlink" ? (
                            <div>
                              <embed
                                src={`${content.embedded_link}`}
                                width="100%"
                                height="100vh"
                              ></embed>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </Accordion.Collapse>
                      {this.state.lessoncontent.length ===
                      this.state.lessoncontent.indexOf(content) + 1 ? null : (
                        <hr />
                      )}
                    </div>
                  );
                })}
              </Accordion>
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default connect(mapStateToProps)(LessonCard);
